import { Page } from '@/core/architecture'

import { ItemMissionsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ItemMissions Page
 * Implemented as a practical sample.
 */
export const ItemMissions: Page = () => {
  const { state, actions } = useViewModel()

  return <ItemMissionsTemplate state={state} {...actions} />
}
